<template>
    <v-container class="pa-0" grid-list-md>
        <v-layout row align-center justify-center>
            <v-flex xs4>
                <v-autocomplete
                    label="Plant"
                    :items="plants"
                    :value="selectedPlantID"
                    @input="handlePlantSelected"
                    hide-details
                    dense
                    outline
                    :read-only="plants.length == 1">
                </v-autocomplete>
            </v-flex>
            <v-flex shrink v-if="plantSelected">
                <HarvestPlanDateSelector 
                    :value="selectedDate"
                    @input="onDateSelected">
                </HarvestPlanDateSelector>
            </v-flex>
            <v-flex xs4 v-if="harvestPlan && categories.length > 0">
                <v-autocomplete
                    v-if="harvestPlan"
                    label="Category"
                    :items="categories"
                    :value="selectedCategoryIDs"
                    @input="handleCategorySelected"
                    multiple
                    hide-details
                    dense
                    outline
                    :read-only="categories.length == 1">
                </v-autocomplete>
            </v-flex>
            <v-flex xs2 v-if="harvestPlan && categorySelected">
                <v-autocomplete
                    v-if="harvestPlan && categorySelected"                    
                    label="UOM"
                    :items="$Constants.HARVESTPLAN_UOM"
                    item-value="ID"
                    item-text="Name"
                    :value="selectedUOM"
                    @input="handleUOMSelected"
                    hide-details
                    dense
                    outline
                    :disabled="updatingHarvestPlan">
                </v-autocomplete>
            </v-flex>                       
        </v-layout>
    </v-container>
</template>

<script>
import UtilService from '@/services/utilService.js';
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import HarvestPlanDateSelector from '@/components/harvestPlan/HarvestPlanDateSelector.vue'

export default {
    components: {
        HarvestPlanDateSelector
    },
    props: {
    },
    data(){
        return {
            uom: []
        };
    },
    computed: {
        ...mapState("HarvestPlanStore", [
            "plantData",
            "selectedPlantID",
            "selectedCategoryIDs",
            "selectedDate",
            "harvestPlan",
            "updatingHarvestPlan"
        ]),
        ...mapGetters("HarvestPlanStore", [            
            "selectedUOM"
        ]),
        plants(){
            return this.plantData.map(x => {
                return {
                    text: x.PlantName,
                    value: x.PlantID
                };
            }).sort(UtilService.sortAscending(x => x.text));
        },
        categories(){
            if(this.harvestPlan == null || this.harvestPlan.HarvestPlanUOMs == null){
                return [];
            }

            return this.harvestPlan.HarvestPlanUOMs.map(x => {
                return {
                    text: x.ProductCategoryName + ' (' + this.$Constants.HARVESTPLAN_UOM_ENUM[x.UOM].Name + ')',
                    value: x.ProductCategoryID
                };
            }).sort(UtilService.sortAscending(x => x.text));
        },
        plantSelected(){
            return this.selectedPlantID != null;
        },
        categorySelected(){
            return this.selectedCategoryIDs != null && (this.selectedCategoryIDs.length > 0 || this.selectedCategoryIDs > 0);
        },
        dateSelected() {
            return this.selectedDate != null;
        }
    },
    methods: {
        ...mapMutations("HarvestPlanStore", [
            "setSelectedPlantID",
            "setSelectedCategoryIDs",
            "setSelectedDate",
            "setSeletedUOM"
        ]),
        ...mapActions("HarvestPlanStore", [
            "loadWeatherData",
            "loadHarvestPlan",
            "updateHarvestPlanUOM",
            "loadPlantUnits",
            "loadSettings"
        ]),
        async handlePlantSelected(value){
            this.setSelectedPlantID(value);
            if(this.selectedPlantID != null) {
                // Weather data is not used in any subsequent data so it can be loaded separately
                this.loadWeatherData();
                await this.loadPlantUnits();
            }            

            if (this.plantSelected && this.dateSelected) {
                await this.loadSettings();
                await this.loadHarvestPlan();
            }

            if(this.categories.length == 1){
                this.handleCategorySelected([this.categories[0].value]);
            } else if(!this.categories.some(x => x.value == this.selectedCategoryID)){
                this.handleCategorySelected(null);
            } else {
                this.handleCategorySelected([this.selectedCategoryID])
            }
        },
        async onDateSelected(date) {
            this.setSelectedDate(date);

            if (this.plantSelected && this.dateSelected) {
                await this.loadHarvestPlan();

                if(this.harvestPlan && this.harvestPlan.HarvestPlanUOMs.length == 1) {
                    this.setSelectedCategoryIDs([this.harvestPlan.HarvestPlanUOMs[0].ProductCategoryID]);
                } else {
                    this.setSelectedCategoryIDs(null);
                }
            }
        },
        async handleCategorySelected(value){            
            this.setSelectedCategoryIDs(value);
        },
        async handleUOMSelected(value) {
            this.setSeletedUOM(value);

            await this.updateHarvestPlanUOM();
        }
    },
    created(){
        if(this.plants.length == 1){
            this.handlePlantSelected(this.plants[0].value)
        } else if(!this.plants.some(x => x.value == this.selectedPlantID)){
            this.handlePlantSelected(this.$store.getters["UserStore/primaryPlantID"]);
        }
    }
}
</script>